import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IComponentTreeButtonState {}

export interface IComponentTreeButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class ComponentTreeButton extends PureSdComponent<IComponentTreeButtonProps & IWithSDProps, IComponentTreeButtonState> {
  constructor(props: IComponentTreeButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.DisplayItemTree);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.DisplayItemTree);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.DisplayItemTreeButton) === Visibility.Visible && (
          <KuikaButton
            data-testid="leftMenuItemTreeTabButton"
            data-onboarding-id="left_menu_item-tree"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.DisplayItemTree)}
            onClick={this.handleClick}
          >
            <KuikaSvg type="sidebar-icons" name="list-tree" width={18} height={18} pointer />
          </KuikaButton>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const componentTreeButton = withSD<IComponentTreeButtonProps>(ComponentTreeButton);
export { componentTreeButton as ComponentTreeButton };
